import { render, staticRenderFns } from "./RecentActivityTableDescriptionBookingCreated.vue?vue&type=template&id=ed34b0cc&"
import script from "./RecentActivityTableDescriptionBookingCreated.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionBookingCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports